import StatusBadge from 'components/atoms/status-badge'
import { PROCESS_STATUS } from 'domains/seller-market-product/constants'
import PropTypes from 'prop-types'

const proptypes = {
  status: PropTypes.string
}

/**
 * To give nice look on Seller Market Product `status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} confirm_price_status Seller Product price status. available values
 * - `pending`
 * - `on_review
 * - `reviewed`
 * - `photo_edited`
 * - `photo_uploaded`
 * - `completed`
 * - `rejected`
 */
const SellerMarketProductStatusBadge = ({ status }) => {

  const colorMap = {
    [PROCESS_STATUS.INCOMPLETE]     : 'secondary',
    [PROCESS_STATUS.PENDING]        : 'secondary',
    [PROCESS_STATUS.ON_REVIEW]      : 'info',
    [PROCESS_STATUS.REVIEWED]       : 'primary',
    [PROCESS_STATUS.PHOTO_EDITED]   : 'warning',
    [PROCESS_STATUS.PHOTO_UPLOADED] : 'warning',
    [PROCESS_STATUS.COMPLETED]      : 'success',
    [PROCESS_STATUS.REJECTED]       : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

SellerMarketProductStatusBadge.propTypes = proptypes

export default SellerMarketProductStatusBadge
